import "../../../resources/less/Admin/Licences/AddLicenceClass.less";
import NanomonxForm from "../../components/Forms/NanomonxForm";

class AddLicenceClass {
  constructor() {
    if ($(".purchase_email_form").length > 0) {
      new NanomonxForm({
        elementName: "purchase_email_form",
        submitClass: ".form-validate-email-submit",
        withValidation: false,
      });
    }
  }
}

$(window).on("load", () => {
  new AddLicenceClass();
});
